import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";
import { puedeVerUtilidadTiendas } from "./usuariosUtilidadTiendas";

function BotonesReportesVentas() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Ventas", items: [
      { label: "Venta Mensual", icon: "fas fa-chart-line", color: "#10b981", href: "/GraficaVentasMensualComparativa", desc: "Comparativo mensual", enabled: !!user.menu_reportes },
      { label: "Venta por Cliente", icon: "fas fa-user-tie", color: "#3b82f6", href: "/GraficaVentasMensualCliente", desc: "Mensual por cliente", enabled: !!user.menu_reportes },
      { label: "Venta por Departamento", icon: "fas fa-store", color: "#14b8a6", href: "/GraficaVentasDepartamento", desc: "Por departamento", enabled: !!user.menu_reportes },
      { label: "Venta por Grupo", icon: "fas fa-users", color: "#06b6d4", href: "/GraficaVentasGrupo", desc: "Por grupo", enabled: !!user.menu_reportes },
      { label: "Venta por Estado", icon: "fas fa-globe-americas", color: "#6366f1", href: "/GraficaVentasEstado", desc: "Por estado", enabled: !!user.menu_reportes },
      { label: "Desglose Ventas", icon: "fas fa-chart-bar", color: "#8b5cf6", href: "/GraficaVentasDesgloce", desc: "Desglose", enabled: !!user.menu_reportes },
      { label: "Ventas Tabla", icon: "fas fa-list", color: "#64748b", href: "/DashboardVentasTabla", desc: "Vista tabular", enabled: !!user.menu_reportes },
    ]},
    { section: "Vendedores", items: [
      { label: "Venta por Vendedor", icon: "fas fa-address-card", color: "#3b82f6", href: "/GraficaVentasVendedor", desc: "Por vendedor", enabled: !!user.menu_reportes },
      { label: "Mensual por Vendedor", icon: "fas fa-chart-bar", color: "#3b82f6", href: "/GraficaVentasMensualVendedor", desc: "Mensual", enabled: !!user.menu_reportes },
    ]},
    { section: "Rentabilidad", items: [
      { label: "Utilidad por Venta", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ReporteUtilidadesVenta", desc: "Por nota", enabled: !!user.menu_reportes },
      { label: "Utilidad por Modelo", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ReporteUtilidadesArticulo", desc: "Por modelo", enabled: !!user.menu_reportes },
      { label: "Utilidad por Linea", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ReporteUtilidadesLinea", desc: "Por linea", enabled: !!user.menu_reportes },
      { label: "Utilidad por Cliente", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ReporteUtilidadesCliente", desc: "Por cliente", enabled: !!user.menu_reportes },
      { label: "Utilidad Tiendas", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ReporteUtilidadesTiendas", desc: "Ventas de tienda", enabled: puedeVerUtilidadTiendas(user) },
      { label: "Valor Inventario", icon: "fas fa-money-check-alt", color: "#f59e0b", href: "/ValorInventario", desc: "Valorizado", enabled: !!user.menu_reportes },
    ]},
    { section: "Sell Thru", items: [
      { label: "Sell Thru", icon: "fas fa-search-dollar", color: "#8b5cf6", href: "/SellThru", desc: "Rotacion general", enabled: !!user.menu_reportes },
      { label: "Sell Thru Area", icon: "fas fa-search-dollar", color: "#8b5cf6", href: "/SellThruArea", desc: "Por area", enabled: !!user.menu_reportes },
      { label: "Sell Thru Global", icon: "fas fa-search-dollar", color: "#8b5cf6", href: "/SellThruAreaGlobal", desc: "Global", enabled: !!user.menu_reportes },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Reportes de Ventas"
      descripcion="Analisis comercial y rentabilidad"
      icono="fas fa-chart-line"
      color="#10b981"
      secciones={SECCIONES}
    />
  );
}

export default BotonesReportesVentas;
